var AttributedString, ElementType, addDOMNodeToAttributedString, assert, bmlTags, dom, htmlparser;

AttributedString = require('./attributed-string');

bmlTags = require('./attributed-string-bml-tags');

ElementType = require('domelementtype');

htmlparser = require('htmlparser2');

assert = require('./util').assert;

dom = require('./dom');

AttributedString.fromInlineBMLString = function(inlineBMLString) {
  var handler, parser, result;
  result = null;
  handler = new htmlparser.DomHandler((function(_this) {
    return function(error, dom) {
      if (error) {
        return console.log(error);
      } else {
        return result = _this.fromInlineBML(dom);
      }
    };
  })(this));
  parser = new htmlparser.Parser(handler, {
    decodeEntities: true,
    lowerCaseTags: true
  });
  parser.write(inlineBMLString);
  parser.done();
  return result;
};

AttributedString.fromInlineBML = function(domArray) {
  var attributedString, each, i, len;
  if (domArray.length === 0) {
    new AttributedString();
  }
  if (domArray.length === 1 && domArray[0].type === ElementType.Text) {
    return new AttributedString(domArray[0].data);
  } else {
    attributedString = new AttributedString();
    for (i = 0, len = domArray.length; i < len; i++) {
      each = domArray[i];
      addDOMNodeToAttributedString(each, attributedString);
    }
    return attributedString;
  }
};

AttributedString.validateInlineBML = function(inlineBMLContainer) {
  var each, end, results, tagName;
  end = dom.nodeNextBranch(inlineBMLContainer);
  each = dom.nextNode(inlineBMLContainer);
  results = [];
  while (each !== end) {
    if (tagName = each.name) {
      assert(bmlTags[tagName], "Unexpected tagName '" + tagName + "' in 'P'");
    }
    results.push(each = dom.nextNode(each));
  }
  return results;
};

addDOMNodeToAttributedString = function(node, attributedString) {
  var each, image, lineBreak, tagStart, type;
  type = node.type;
  if (type === ElementType.Text) {
    return attributedString.appendText(new AttributedString(node.data.replace(/(\r\n|\n|\r)/gm, '')));
  } else if (type === ElementType.Tag) {
    tagStart = attributedString.getLength();
    each = dom.firstChild(node);
    if (each) {
      while (each) {
        addDOMNodeToAttributedString(each, attributedString);
        each = each.next;
      }
      if (bmlTags[node.name]) {
        return attributedString.addAttributeInRange(node.name, node.attribs, tagStart, attributedString.getLength() - tagStart);
      }
    } else if (bmlTags[node.name]) {
      if (node.name === 'br') {
        lineBreak = new AttributedString(AttributedString.LineSeparatorCharacter);
        lineBreak.addAttributeInRange('br', node.attribs, 0, 1);
        return attributedString.appendText(lineBreak);
      } else if (node.name === 'img') {
        image = new AttributedString(AttributedString.ObjectReplacementCharacter);
        image.addAttributeInRange('img', node.attribs, 0, 1);
        return attributedString.appendText(image);
      }
    }
  }
};

AttributedString.inlineBMLToText = function(inlineBMLContainer) {
  var each, end, tagName, text, type;
  if (inlineBMLContainer) {
    end = dom.nodeNextBranch(inlineBMLContainer);
    each = dom.nextNode(inlineBMLContainer);
    text = [];
    while (each !== end) {
      type = each.type;
      if (type === ElementType.Text) {
        text.push(each.data);
      } else if (type === ElementType.Tag && !dom.firstChild(each)) {
        tagName = each.name;
        if (tagName === 'br') {
          text.push(AttributedString.LineSeparatorCharacter);
        } else if (tagName === 'img') {
          text.push(AttributedString.ObjectReplacementCharacter);
        }
      }
      each = dom.nextNode(each);
    }
    return text.join('');
  } else {
    return '';
  }
};

module.exports = AttributedString;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/attributed-string-from-bml.js
 ** module id = 18
 ** module chunks = 0
 **/